import React, { FC, memo, useCallback, useContext, useMemo } from 'react'

import { TagsSelectContext } from './TagsSelectContext'

import { TagFragment } from '~generated/operations'
import DotIcon from '~icons/dot.svg'
import { stopPropagation } from '~lib/helpers'
import Menu, { Submenu } from '~lib/ui-kit/Menu'

export type TagsSubmenuProps = {
  label?: string
  tagsIds?: string[]
  onTagSelect: (value: string) => void
  tags?: TagFragment[]
}

// TODO reflect Read Only tags.
const TagsSubmenu: FC<React.PropsWithChildren<TagsSubmenuProps>> = ({
  label = 'Assign tag',
  tagsIds,
  onTagSelect,
  tags,
}) => {
  const { tags: tagsFromContext } = useContext(TagsSelectContext)

  const tagsToUse = useMemo(() => {
    const arr = [...(tags || tagsFromContext)]
    if (!tagsIds) return arr
    // TODO Fix blockers in Select component and add ability to display selected items at the top of the list
    return [...arr.filter((tag) => tagsIds.includes(tag.id)), ...arr.filter((tag) => !tagsIds.includes(tag.id))]
  }, [tags, tagsFromContext, tagsIds])

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation()
      const tagId = e.currentTarget.dataset.value
      onTagSelect(tagId)
    },
    [onTagSelect]
  )

  return (
    <Submenu label={label} onClick={stopPropagation}>
      {tagsToUse?.map(({ id, color, label }) => (
        <Menu.Item
          key={id}
          data-value={id}
          icon={<DotIcon fill={color} />}
          selected={tagsIds?.includes(id)}
          onClick={handleClick}
        >
          {label}
        </Menu.Item>
      ))}
    </Submenu>
  )
}

export default memo(TagsSubmenu)
